export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9930.f907aeeb.jpg";